import React, { useEffect, useState, useCallback } from 'react';
import { Snackbar } from '@material-ui/core';
import { useLocation } from 'react-router-dom';
import { get } from 'global/lib/lodash';
import { Alert } from 'global/components/alerts';

export default (props) => {
    const { selectedItems, activeEdit } = props;
    const location = useLocation();
    const [alert, setAlert] = useState('');

    const handleClick = useCallback(() => {
        if (get(location, 'state.alert', '') !== alert) {
            setAlert(get(location, 'state.alert', ''));
        }
    }, []);

    useEffect(() => {
        setAlert(get(location, 'state.alert', ''));
    }, [selectedItems, activeEdit]);

    useEffect(() => {
        if (!alert || alert !== get(location, 'state.alert', '')) {
            location.state = { ...location.state, alert: '' };
        }
    }, [alert]);

    useEffect(() => {
        window.addEventListener('click', handleClick);
        return () => {
            window.removeEventListener('click', handleClick);
        };
    }, []);

    return <Snackbar
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
        }}
        open={!!alert}
        autoHideDuration={6000}
        onClose={() => setAlert()}
    >
        {!!alert && (
            <Alert onClose={() => setAlert()} severity={get(location, 'state.severity', 'success')}>
                {alert}
            </Alert>
        )}
    </Snackbar>
}